exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".widgetItemsContainer{width:100%;box-shadow:0 4px 8px 0 rgba(0,0,0,.2);padding-top:.5em;border-radius:.3em;margin-bottom:1em}.widgetContainer{position:relative;width:100%;height:100%}.widgetContainer.Student{font-size:.8em}.widgetContainer .placeholderDisclaimer{text-align:right;font-style:italic;font-size:.9em;margin-bottom:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/widgets/widget_container.scss
// module id = 1318
// module chunks = 0